// @storybook-skip: internal section of LessonDetailViewScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { ScreenBottomActionBar } from "../ScreenBottomActionBar";

type Props = {
	label?: string;
	onPress: () => void;
};

export const LessonDetailBottomBar = ({ label, onPress }: Props) => {
	const { t } = useTranslation();

	return (
		<ScreenBottomActionBar
			label={label ?? t("lessons.detail.takeQuizCta")}
			onPress={onPress}
		/>
	);
};
